import { render, staticRenderFns } from "./TableUsers.vue?vue&type=template&id=f67f7234&"
import script from "./TableUsers.vue?vue&type=script&lang=ts&"
export * from "./TableUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports